import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rbzxz9sh4: FaireProductEntity = {
  token: "p_7rbzxz9sh4",
  type: "product",
  name: "Lavender 40/42 Essential Oil Blend",
  brandToken: "b_9p9pjx33",
  brandName: "Simply Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/d14ae8e37adb7f71413fa5642c48c0630d95571aa75a2cb5144fa80d26cb9f44.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43ba9ca8253550ed8d9b3b0a5d57f273ec08b26dcd28969e66d90fa4a3af15fd.png",
    "https://cdn.faire.com/fastly/51eed336f059db940b5420165a3f85f7c4473e48c13d69f5b1838129231fd49f.png",
    "https://cdn.faire.com/fastly/7d40ef51d79bc29834698e6780d624dc28ff5900a3b3305f8de783caee5dd153.jpeg",
    "https://cdn.faire.com/fastly/be197a8c7453409a8a30df565f1fc593e0d551e6fec46682e2d9278d4bfcd73f.jpeg",
    "https://cdn.faire.com/fastly/d350ff52c959ceb6176d5b22bcca4bba8d41785590df1bdf4ceebc7f564b50e8.jpeg",
    "https://cdn.faire.com/fastly/21ab92cbbbf65ea4ce729828c13b59501f57c47b30db2864490a297709098250.jpeg",
  ],
  priceDollars: 37.41,
  description:
    "Product Details\nOne of the most well-known and commonly used essential oils in aromatherapy, Lavender boasts a wide array of benefits including promoting healthier skin and hair, supporting the immune system, and aiding in sleep. \n\nUses:\nCalms\nPromotes healthy skin\nRelieves sore Muscles\nRelaxes\nBoosts immunity\n\nCautions:\nKid Safe: Yes, 2+\nPregnancy Safe: Yes, consult a doctor\nBreastfeeding Safe: Yes, consult a doctor\nCat Safe: No\nDog Safe: Yes\nSpecial Dilution Rate: None \nMore Safety Info: Storage life up to 4 years.\n",
  tags: [],
  msrpDollars: 74.81,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:50.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
